import type { EmpresaGrupo, EmpresaPublica, TreeSlot } from './types'

export const TOKEN_KEY = 'hi_candidato_token'
export const PERFIL_KEY = 'hi_candidato_perfil'
export const AUTH_PURPOSE_KEY = 'hi_candidato_auth_purpose'

export const API_BASE = '/api/v1'

export const ASSET_ICON = '/assets/apple-touch-icon.png'
export const ASSET_HI_LOGO = '/assets/hi-logo.webp'

/**
 * Marcas exibidas no filtro / árvore de Carreiras (deixar o restante para expandir depois).
 * Ordem = ordem dos chips.
 */
export const CARREIRAS_MARCAS_PRINCIPAIS: string[] = [
  'lavanderia-60-minutos',
  'ikli',
  'paylav',
]

export const CARREIRAS_MARCAS_PRINCIPAIS_SET = new Set(CARREIRAS_MARCAS_PRINCIPAIS)

/** Etapas públicas do processo (resumo do pipeline ATS interno). */
export const PROCESSO_PASSOS_DEFAULT = [
  'Candidatura recebida',
  'Análise do currículo',
  'Contato do RH',
  'Entrevistas / avaliação',
  'Proposta',
  'Boas-vindas ao time',
]

export const FALLBACK_EMPRESAS: EmpresaGrupo[] = [
  {
    slug: 'grupo-hi',
    nome: 'Grupo HI',
    nome_curto: 'Grupo HI',
    tagline: 'Transformamos tecnologia em eficiência',
    sobre: 'Holding do ecossistema HI.',
    site_url: 'https://grupohi.com.br/',
    logo_url: '/assets/empresas/grupo-hi.png',
    cor_primaria: '#000070',
    cor_secundaria: '#39FF14',
    areas: ['Holding'],
    total_vagas: 0,
    eh_holding: true,
    destaque: false,
    parent_slug: null,
    ordem: 0,
  },
  {
    slug: 'lavanderia-60-minutos',
    nome: 'Lavanderia 60 Minutos',
    nome_curto: '60 Minutos',
    tagline: 'Maior rede self-service da América Latina',
    sobre: 'Carro-chefe do Grupo HI.',
    site_url: 'https://www.lavanderia60minutos.com.br/',
    logo_url: '/assets/empresas/lavanderia-60-minutos.png',
    cor_primaria: '#001a4d',
    cor_secundaria: '#39FF14',
    areas: ['Franquias', 'Self-service'],
    total_vagas: 0,
    eh_holding: false,
    destaque: true,
    parent_slug: 'grupo-hi',
    ordem: 1,
  },
  {
    slug: 'hipag',
    nome: 'HiPag',
    nome_curto: 'HiPag',
    tagline: 'Pagamentos e app HI',
    sobre: '',
    site_url: 'https://www.hipag.com.br/',
    logo_url: '/assets/empresas/hipag.png',
    cor_primaria: '#0A0A0A',
    cor_secundaria: '#39FF14',
    areas: ['Pagamentos'],
    total_vagas: 0,
    eh_holding: false,
    destaque: false,
    parent_slug: 'grupo-hi',
    ordem: 2,
  },
  {
    slug: 'hibank',
    nome: 'HI Bank',
    nome_curto: 'HI Bank',
    tagline: 'Soluções financeiras',
    sobre: '',
    site_url: '',
    logo_url: '/assets/empresas/hibank.png',
    cor_primaria: '#0A0A0A',
    cor_secundaria: '#39FF14',
    areas: ['Financeiro'],
    total_vagas: 0,
    eh_holding: false,
    destaque: false,
    parent_slug: 'grupo-hi',
    ordem: 3,
  },
  {
    slug: 'hi-clinica',
    nome: 'Hi Clínica',
    nome_curto: 'Hi Clínica',
    tagline: 'Saúde no ecossistema HI',
    sobre: '',
    site_url: '',
    logo_url: '/assets/empresas/hi-clinica.png',
    cor_primaria: '#0A0A0A',
    cor_secundaria: '#39FF14',
    areas: ['Saúde'],
    total_vagas: 0,
    eh_holding: false,
    destaque: false,
    parent_slug: 'grupo-hi',
    ordem: 4,
  },
  {
    slug: 'hi-club',
    nome: 'Hi Club',
    nome_curto: 'Hi Club',
    tagline: 'Fidelidade HI',
    sobre: '',
    site_url: '',
    logo_url: '/assets/empresas/hi-club.png',
    cor_primaria: '#0A0A0A',
    cor_secundaria: '#39FF14',
    areas: ['Fidelidade'],
    total_vagas: 0,
    eh_holding: false,
    destaque: false,
    parent_slug: 'grupo-hi',
    ordem: 5,
  },
  {
    slug: 'hi-plim',
    nome: 'Hi Plim',
    nome_curto: 'Hi Plim',
    tagline: 'Higiene e limpeza',
    sobre: '',
    site_url: '',
    logo_url: '/assets/empresas/hi-plim.png',
    cor_primaria: '#0A0A0A',
    cor_secundaria: '#39FF14',
    areas: ['Higiene'],
    total_vagas: 0,
    eh_holding: false,
    destaque: false,
    parent_slug: 'grupo-hi',
    ordem: 6,
  },
  {
    slug: 'ikli',
    nome: 'Ikli Tecnologia',
    nome_curto: 'Ikli',
    tagline: 'Software e IA',
    sobre: '',
    site_url: 'https://ikli.com.br/',
    logo_url: '/assets/empresas/ikli.png',
    cor_primaria: '#0A0A0A',
    cor_secundaria: '#39FF14',
    areas: ['Software', 'IA'],
    total_vagas: 0,
    eh_holding: false,
    destaque: false,
    parent_slug: 'grupo-hi',
    ordem: 7,
  },
  {
    slug: 'ikli-ads',
    nome: 'Ikli Ads',
    nome_curto: 'Ikli Ads',
    tagline: 'Mídia e anúncios',
    sobre: '',
    site_url: 'https://ikli.com.br/',
    logo_url: '/assets/empresas/ikli-ads.png',
    cor_primaria: '#0A0A0A',
    cor_secundaria: '#39FF14',
    areas: ['Ads'],
    total_vagas: 0,
    eh_holding: false,
    destaque: false,
    parent_slug: 'grupo-hi',
    ordem: 8,
  },
  {
    slug: 'laundryinbox',
    nome: 'laundryinBOX',
    nome_curto: 'laundryinBOX',
    tagline: 'Lavanderia em box',
    sobre: '',
    site_url: '',
    logo_url: '/assets/empresas/laundryinbox.png',
    cor_primaria: '#0A0A0A',
    cor_secundaria: '#39FF14',
    areas: ['Box'],
    total_vagas: 0,
    eh_holding: false,
    destaque: false,
    parent_slug: 'grupo-hi',
    ordem: 9,
  },
  {
    slug: 'bolepix',
    nome: 'Meu Bolepix',
    nome_curto: 'Bolepix',
    tagline: 'Boleto + Pix',
    sobre: '',
    site_url: '',
    logo_url: '/assets/empresas/bolepix.png',
    cor_primaria: '#0A0A0A',
    cor_secundaria: '#39FF14',
    areas: ['Pagamentos'],
    total_vagas: 0,
    eh_holding: false,
    destaque: false,
    parent_slug: 'grupo-hi',
    ordem: 10,
  },
  {
    slug: 'paylav',
    nome: 'Paylav',
    nome_curto: 'Paylav',
    tagline: 'Máquinas e equipamentos',
    sobre: '',
    site_url: 'http://paylav.com.br/',
    logo_url: '/assets/empresas/paylav.png',
    cor_primaria: '#0A0A0A',
    cor_secundaria: '#39FF14',
    areas: ['Equipamentos'],
    total_vagas: 0,
    eh_holding: false,
    destaque: false,
    parent_slug: 'grupo-hi',
    ordem: 11,
  },
]

export const LOGO_FALLBACKS: Record<string, string> = {
  'grupo-hi': '/assets/empresas/grupo-hi.png',
  hi: '/assets/empresas/grupo-hi.png',
  'hi-holding': '/assets/empresas/grupo-hi.png',
  'lavanderia-60-minutos': '/assets/empresas/lavanderia-60-minutos.png',
  '60-minutos': '/assets/empresas/lavanderia-60-minutos.png',
  hipag: '/assets/empresas/hipag.png',
  hibank: '/assets/empresas/hibank.png',
  'hi-clinica': '/assets/empresas/hi-clinica.png',
  'hi-club': '/assets/empresas/hi-club.png',
  'hi-plim': '/assets/empresas/hi-plim.png',
  ikli: '/assets/empresas/ikli.png',
  'ikli-ads': '/assets/empresas/ikli-ads.png',
  laundryinbox: '/assets/empresas/laundryinbox.png',
  bolepix: '/assets/empresas/bolepix.png',
  paylav: '/assets/empresas/paylav.png',
}

/** Só Lavanderia 60 Minutos usa placa clara; demais têm traço branco → placa navy. */
export const LOGOS_LIGHT_PLATE = new Set(['lavanderia-60-minutos', '60-minutos'])

/** Slots do modelo grupo-hi.html (left/top %). Hero = destaque. */
export const TREE_SLOTS: TreeSlot[] = [
  { left: 50, top: 10, hero: true },
  { left: 17, top: 24.3, row: 0 },
  { left: 83, top: 24.3, row: 0 },
  { left: 13, top: 43.4, row: 1 },
  { left: 87, top: 43.4, row: 1 },
  { left: 15, top: 62, row: 2 },
  { left: 85, top: 62, row: 2 },
  { left: 28, top: 76.7, row: 3 },
  { left: 72, top: 76.7, row: 3 },
  { left: 62, top: 34, row: 4 },
  { left: 38, top: 34, row: 4 },
]

export const EMPRESA_FALLBACK: EmpresaPublica = {
  empresa: 'Grupo HI',
  tagline: 'Transformamos tecnologia em eficiência',
  apresentacao:
    'O Grupo HI (Hi Holding) é um ecossistema empresarial em Cabedelo / João Pessoa — PB, que une franquias 60 Minutos, tecnologia, máquinas e higiene. Transformamos tecnologia em eficiência.',
  cidade: 'Cabedelo',
  uf: 'PB',
  regiao: 'Grande João Pessoa, Paraíba',
  valores: ['Ética', 'Meritocracia', 'Inclusão', 'Inovação'],
}
